import { z, ZodSchema } from "zod";

import type { Operation } from "server/auth/types";

import type { Checklist, ChecklistBlock } from "../types";

export const allowed: Checklist["allowed"] = (block) => {
  if (!block.config.tableId) {
    return [];
  }

  const operations: Operation[] = [];

  const canCreateListItems = block.config.canCreateListItems;
  const canViewListItemDetails = block.config.canViewDetails;

  if (canViewListItemDetails || canCreateListItems) {
    /**
     * The `tableFields.getChoices` query fires
     * when user has a dynamic dropdown field (dropdown with linked table) attached to the checklist block.
     */
    operations.push({
      type: "query",
      path: "tableFields.getChoices",
      validator: z.object({
        tableId: z.literal(block.config.tableId),
        fieldId: fieldInDetailFields(block.config),
      }),
    });

    operations.push({
      type: "query",
      path: "tableFields.getChoicesByFieldId",
      validator: z.object({
        tableId: z.literal(block.config.tableId),
        fieldId: fieldInDetailFields(block.config),
      }),
    });
  }

  return operations;
};

function fieldInDetailFields(config: ChecklistBlock["config"]) {
  return z.number().refine((fieldId) => {
    return config.listItemDetailFields.includes(fieldId);
  });
}
